require('./purchaseFormController');
require('../../pricing/plans/planCardDirective');

"use strict";

angular.module('app.purchase.purchaseForm.purchaseFormDirective', [
  'app.purchase.purchaseForm.purchaseFormController',
  'app.pricing.plans.planCardDirective',
])
  .directive('purchaseForm', [
    function () {
      return {
        restrict: 'EA',
        templateUrl: 'components/purchase/purchaseForm/purchaseFormView.html',
        controller: 'app.purchase.purchaseForm.purchaseFormController',
        scope: {
          showManage: '<?',
          plans: '<',
          currentSubscription: '<?',
          fetchSubscription: '<?',
          fetchPlans: '<?',
          useServiceBreaker: '<?',
          groupedPlans: '<?'
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/purchaseForm/purchaseFormDirective.js